export default [
  {
    path: 'dashboard',
    name: 'OldDashboard',
    component: () => import('@/views/Factory/Dashboard/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'overview',
      template: 'auth',
    },
  },
  {
    path: 'dashboard-main',
    name: 'dashboard',
    component: () => import('@/views/Factory/Dashboard/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'overview',
      template: 'auth',
    },
  },
];
